import { combineReducers } from "@reduxjs/toolkit"

import authReducer from "stores/auth/authSlice"
import bookingReducer from "stores/booking/bookingSlice"
import currencyReducer from "stores/currency/currencySlice"
import favoriteReducer from "stores/favorites/favoritesSlice"
import localSearchReducer from "stores/local-search/localSearchSlice"
import multiUnitReducer from "stores/multi-unit-detail/multiUnitSlice"
import priceDropReducer from "stores/price-drop/priceDropSlice"
import saveSearchReducer from "stores/save-search/saveSearchSlice"
import searchReducer from "stores/search/searchSlice"
import uiReducer from "stores/ui/uiSlice"

const rootReducer = combineReducers({
  authReducer,
  bookingReducer,
  searchReducer,
  uiReducer,
  favoriteReducer,
  saveSearchReducer,
  currencyReducer,
  localSearchReducer,
  multiUnitReducer,
  priceDropReducer,
})

export default rootReducer
